module.exports = __webpack_public_path__ + "img/slide4.d69cb331.png";